import { RadioGroupRoot } from './RadioGroup'
import { RadioGroupOption } from './RadioGroupOption'

export type { RadioProps, RadioSize } from './types'
export type {
  RadioGroupProps,
  RadioGroupOptionProps,
  RadioGroupSize,
  RadioGroupOrientation,
} from './types'

export const RadioGroup = Object.assign(RadioGroupRoot, {
  Option: RadioGroupOption,
})

export { Radio } from './Radio'
